export default __webpack_public_path__ + "static/maitakeshover-c91fdcb1c5603711d5daef81179f0673.png";